export default __webpack_public_path__ + "static/media/S-032.39605cca.png";